<template>
  <div class="dialog_wrap" @click="closeDialog">
    <div class="dialog_wrap_award" @click.stop="noTouch">
      <div class="dialog_wrap_close" @click="closeDialog"></div>
      <div class="wrap_award_content">
        <!-- <div class="wrap_award_title"></div> -->
        <div class="wrap_award_desc">
          <div class="award_title">请长按扫码关注我们</div>
          <div class="award_item">
            <img :src="staticUrl+'office/xzdzm/reservation/wx_link.jpg'" class="jiangli-icon">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'WxLink',
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['isMobile','staticUrl']),
  },
  mounted () {
    document.getElementsByTagName('body')[0].classList.add('noscroll');
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].classList.remove('noscroll');
  },
  methods: {
    noTouch () {

    },
    closeDialog () {
      // if (this.$route.name === 'reservation' || this.$route.name === 'home' || this.$route.name === '' ) {
        this.$emit('onClose', true)
      // } else {
      //   this.$router.push({ name: 'reservation', query: this.$route.query })
      // }
    }
  }
}
</script>

<style lang="scss">

</style>
